import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { applyTenantBranding } from "@/lib/tenantHost";
import { applyTenantCurrency } from "@/lib/currency";
import { applyBackgroundTheme } from "@/lib/backgroundThemes";

/**
 * Applies tenant primary/accent CSS variables to :root so the whole shell
 * (charts, buttons, chips) rebrands live. Hex, HSL-wrapped, or HSL-triple
 * values are all normalised inside `applyTenantBranding` so buttons stay
 * contrast-safe regardless of what the branding form stored.
 * Also stamps the tenant's ISO 4217 currency onto the document root so any
 * `formatMoney(x)` call across the app formats in that currency, and applies
 * the tenant's chosen background theme to <body>.
 */
export function TenantBrandingBridge() {
  const { tenant } = useAuth();
  useEffect(() => {
    if (!tenant) return;
    applyTenantBranding(tenant);
    applyTenantCurrency(tenant.currency);
    // wallpaper_url comes as `/api/tenant/wallpaper/<slug>?v=…` — prefix the
    // backend origin so CSS `background-image: url(...)` resolves cross-env.
    const url = tenant.wallpaper_url
      ? `${process.env.REACT_APP_BACKEND_URL}${tenant.wallpaper_url}`
      : null;
    applyBackgroundTheme(tenant.background_theme, url, tenant.wallpaper_overlay_pct);
  }, [tenant]);
  return null;
}
